import React, { useState, useEffect, useRef } from "react";
import PillWithButton from "../PillWithButton";
import { map, isMatch, lowerCase, differenceWith, isEqual } from "lodash";
import "./PanelAddTags.scss";

export default function PanelAddTags(props) {
  const {
    tags,
    allLabel,
    name,
    onRemove,
    onAddLabel,
    value = "",
    onChange,
  } = props;
  const [findedTags, setFindedTags] = useState([]);
  const inputRef = useRef(null);
  const listRef = useRef(null);

  const showListItems = (event) => {
    event.stopPropagation();

    if (listRef.current) {
      listRef.current.style.display = "flex";
    }
  };

  const hideListItems = (event) => {
    event.stopPropagation();

    if (listRef.current && event.target.className !== "suggested") {
      listRef.current.style.display = "none";
    }
  };

  useEffect(() => {
    if (inputRef.current && listRef.current) {
      inputRef.current.addEventListener("click", showListItems);

      document.addEventListener("click", hideListItems);
    }

    return function cleanup() {
      document.removeEventListener("click", hideListItems);
    };
  }, []);

  useEffect(() => {
    let newTags = [];
    let newFindedTags = differenceWith(allLabel, tags, isEqual);

    map(newFindedTags, (label) => {
      if (isMatch(lowerCase(label.name), lowerCase(value)) && value !== "") {
        newTags.push(label);
      }
    });

    setFindedTags(newTags);
  }, [value, allLabel, tags]);

  return (
    <div className="container">
      <div className="panel-container">
        {map(tags, (tag) => (
          <PillWithButton
            key={tag.id}
            pill={tag.name}
            onRemove={() => onRemove(tag)}
          />
        ))}

        <input
          ref={inputRef}
          type="text"
          autoComplete="off"
          name={name}
          value={value || ""}
          onChange={onChange}
        />
      </div>

      <div className="suggested" ref={listRef}>
        {map(findedTags, (findedTag) => (
          <div
            key={findedTag.id}
            onClick={() => onAddLabel(findedTag)}
            className="suggested-item"
          >
            <p>{findedTag.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
